module.exports = __webpack_public_path__ + "img/no-img.b5250cb0.svg";